module.exports = __webpack_public_path__ + "static/media/CondicoesRegras.789cb104.pdf";